module.exports = __webpack_public_path__ + "static/curso-react-ninja-8da438e2398cc00d9d3b392a895ed9c1.png";